import React from 'react';
import { translate } from '../translations';
import { getTheme } from '../Theme';

import { ReactComponent as LocationIcon } from '../icons/contact_location.svg';
import { ReactComponent as MailingIcon } from '../icons/contact_mailing.svg';

import tempImg from '../images/contact_navImg.png';

const Contact = () => {
  return (
    <>
      <section id="contact">
        <img className={getTheme('template-img')} src={tempImg} alt={'test'} />
        <div className="container">
          <div className={getTheme('col-md-6')}>
            <div className="col-inner-center">
              <div className="contact-content">
                <h2 className="contact-h2">{translate('Lokalizacja')}</h2>
                <LocationIcon className={getTheme('contact-svg')} />
                <div className="contact-p-container">
                  <p className="contact-p">
                    ul. Nadbystrzycka 38H <br /> 20-618 Lublin.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={getTheme('col-md-6')}>
            <div className="col-inner-center">
              <h2 className="contact-h2">{translate('Adres E-mail')}</h2>
              <MailingIcon className={getTheme('contact-svg')} />
              <div className="contact-p-container">
                <div className="contact-p">
                  <h3>{translate('Prezes Zarządu:')} </h3>
                  <a href="mailto:k.dubicki@pollub.pl?subject=Email ze strony filipek-motors.pl&bcc=p.filipek@pollub.pl">
                    <span className={getTheme('mailing')}>
                      @ dr inż. Korneliusz Dubicki
                    </span>
                  </a>{' '}
                </div>
                <br />
                <div className="contact-p">
                  <h3> {translate('Udziałowiec większościowy:')} </h3>
                  <a href="mailto:p.filipek@pollub.pl?subject=Email ze strony filipek-motors.pl">
                    <span className={getTheme('mailing')}>
                      @ dr inż. Przemysław Filipek
                    </span>
                  </a>{' '}
                </div>
                <br />
                <div className="contact-p">
                  <h3> {translate('Udziałowiec mniejszościowy:')} </h3>
                  <a href="mailto:g.klosowski@pollub.pl?subject=Email ze strony filipek-motors.pl&bcc=p.filipek@pollub.pl">
                    <span className={getTheme('mailing')}>
                      @ dr inż. Grzegorz Kłosowski
                    </span>
                  </a>{' '}
                </div>
              </div>
            </div>
          </div>
        </div>

        <iframe
          className={getTheme('contact-iframe')}
          src="https://maps.google.com/maps?q=Lublin%20Nadbystrzycka%2038H&t=&z=13&ie=UTF8&iwloc=&output=embed"
          allowFullScreen
          title={'maps'}
        ></iframe>
      </section>
    </>
  );
};

export default Contact;
